import '../src/stylesheets/static';

// Google Analytics Events
import '../src/javascripts/static/ga-init';

// Images etc.
require.context('../src/images/', true, /^.*/);
require.context('../src/videos/', true, /^.*/);
